import { useEffect, useState } from "react";
import axiosInstance from "../AxiosInstance";

const Alumni = () => {
  const [alumniData, setAlumniData] = useState([]);
  const [visibleCount, setVisibleCount] = useState(9);
  const [loading, setLoading] = useState(true); // ⬅️ Loading state

  useEffect(() => {
    const fetchAlumni = async () => {
      try {
        const response = await axiosInstance.get("/files/page/ALUMNI");
        
        const alumniOnly =  response.data
        setAlumniData(alumniOnly);
      } catch (error) {
        console.error("Failed to fetch alumni data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAlumni();
  }, []);

  const handleViewMore = () => {
    setVisibleCount((prev) => prev + 9);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-[300px] dark:bg-gray-800">
        <div className="w-12 h-12 border-4 border-dashed rounded-full animate-spin border-blue-600 border-t-transparent"></div>
      </div>
    );
  }

  return (
    <div className="dark:bg-gray-800 mt-0">
      <h2 className="text-3xl sm:text-5xl lg:text-6xl text-center lg:my-0 bg-gradient-to-r from-blue-500 to-orange-800 text-transparent bg-clip-text">
        Alumni of Visiga Seminary
      </h2>
      <div className="flex flex-wrap justify-center">
        {alumniData.slice(0, visibleCount).map((alumni) => (
          <div key={alumni.id} className="w-full sm:w-1/2 lg:w-1/3 px-4 py-2">
            <div className="rounded-md p-6 text-md border border-neutral-900 dark:border-neutral-600 bg-white dark:bg-gray-800 text-neutral-900 dark:text-white font-light shadow-lg">
              <div className="flex mt-0 items-start">
                <img
                  className="rounded-md border border-neutral-300 dark:border-neutral-600"
                  src={alumni.photoUrl}
                  alt={alumni.title}
                  style={{ width: "4cm", height: "3cm", objectFit: "cover" }}
                />
                <div className="ml-4">
                  <h6 className="text-neutral-900 dark:text-white">{alumni.title}</h6>
                  <span className="text-sm font-normal italic text-neutral-900 dark:text-neutral-300">
                    {alumni.description}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {visibleCount < alumniData.length && (
        <div className="text-center mt-6">
          <button
            onClick={handleViewMore}
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-md"
          >
            View More
          </button>
        </div>
      )}
    </div>
  );
};

export default Alumni;
